import React, {Fragment, useEffect, useState} from 'react'
import actions from 'redux-auto'
import PropTypes from 'prop-types'
import {isNullOrWhitespace} from 'ag-common/tools/empty'
import {Scrollbar} from 'react-scrollbars-custom'
import Api from '#services/api'
import Task from '#components/m/Status/Task'
import TaskListNewTask from './TaskListNewTask'
import Loading from '#components/a/Loading'
import {usePermissions} from '#hooks/usePermissions'
import useCurrentUser from '#hooks/store/useCurrentUser'

export default function TaskList(props) {
  const permissions = usePermissions()
  const {abteilungen} = useCurrentUser()
  const [taskList, setTaskList] = useState()
  const [newTaskValue, setNewTaskValue] = useState('')
  const [editable, setEditable] = useState(false)

  const {currentAbteilungId, userId, onAufgabenUpdated, backgroundColor} = props

  useEffect(() => {
    fetchList()
    checkIfTaskIsEditable()
  }, [props.currentAbteilungId, abteilungen])

  const checkIfTaskIsEditable = () => {
    if (permissions.praxisaufgaben.edit) {
      setEditable(true)
    } else if (permissions.praxisaufgaben.editOwnAbteilungen) {
      setEditableForMyAbteilungen()
    } else {
      setEditable(false)
    }
  }

  const setEditableForMyAbteilungen = () => {
    let filteredAbteilungen = []
    filteredAbteilungen = abteilungen.filter(abteilungId => abteilungId === currentAbteilungId)
    if (filteredAbteilungen.length >= 1) {
      setEditable(true)
    } else {
      setEditable(false)
    }
  }

  const isNewTaskValueValid = () => !isNullOrWhitespace(newTaskValue)

  const createTask = async () => {
    try {
      const newTask = await Api.createAufgabe(userId, currentAbteilungId, newTaskValue)
      const newTaskList = [newTask, ...taskList]
      setTaskList(newTaskList)
      setNewTaskValue('')
      onAufgabenUpdated(currentAbteilungId, newTaskList)
    } catch (e) {
      actions.error.writeError({error: e})
    }
  }

  const commentTask = async (aufgabeId, text) => {
    try {
      const updatedTask = await Api.commentAufgabe(aufgabeId, text)
      setTaskList(taskList.map(t => (t.id === aufgabeId ? updatedTask : t)))
    } catch (e) {
      actions.error.writeError({error: e})
    }
  }

  const onCheckTaskDone = async taskId => {
    if (!permissions.praxisaufgaben.check) {
      return
    }

    const task = taskList.find(t => t.id === taskId)
    try {
      const updatedTask = await Api.updateAufgabeDone(task.id, !task.done)
      const updatedTaskList = taskList.map(t => (t.id === taskId ? updatedTask : t))
      setTaskList(updatedTaskList)
      onAufgabenUpdated(currentAbteilungId, updatedTaskList)
    } catch (e) {
      actions.error.writeError({error: e})
    }
  }

  const deleteTask = async id => {
    try {
      await Api.deleteAufgabe(id)
      const newTaskList = taskList.filter(t => t.id !== id)
      setTaskList(newTaskList)
      onAufgabenUpdated(currentAbteilungId, newTaskList)
    } catch (e) {
      actions.error.writeError({error: e})
    }
  }

  const handleNewTaskInputChanged = e => {
    setNewTaskValue(e.target.value)
  }

  const handleNewTaskInputKeyPress = async e => {
    if (e.keyCode === 13 && isNewTaskValueValid()) {
      await createTask()
    }
  }

  const handleNewTaskInputBlurred = async () => {
    if (isNewTaskValueValid()) {
      await createTask()
    }
  }

  const fetchList = async () => {
    if (!currentAbteilungId) {
      return
    }
    try {
      const result = await Api.getAufgabenByAbteilung(currentAbteilungId, userId)
      setTaskList(result)
    } catch (e) {
      actions.error.writeError({error: e})
    }
  }

  function renderTasks() {
    if (taskList === undefined) {
      return <Loading />
    }
    return taskList.map(task => (
      <Task
        editable={editable}
        onDelete={() => deleteTask(task.id)}
        task={task}
        key={task.id}
        onChangeHandle={() => onCheckTaskDone(task.id)}
        postComment={commentTask}
        backgroundColor={backgroundColor}
      />
    ))
  }
  return (
    <>
      {editable && (
        <TaskListNewTask
          data-testid="taskListNewTask"
          onKeyDown={handleNewTaskInputKeyPress}
          handleChange={handleNewTaskInputChanged}
          onBlur={handleNewTaskInputBlurred}
          value={newTaskValue}
          backgroundColor={backgroundColor}
        />
      )}
      <Scrollbar className="tasklist" style={{height: '430px'}}>
        {renderTasks()}
      </Scrollbar>
    </>
  )
}

TaskList.propTypes = {
  currentAbteilungId: PropTypes.number,
  userId: PropTypes.number,
  onAufgabenUpdated: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string,
}
